import React from 'react';
import { Reveal } from '../Reveal';
import { Eyebrow } from './SectionBand';
interface ProofOfBuildProps {
  /** Opens Example #1 enlarge so the strip drives into real product proof. */
  onExplore?: () => void;
}

/**
 * Light book → path proof strip. Branded cover + morph metaphor above Example #1.
 * Layout: copy row, then images row, then ruled attribution footer.
 */
export function ProofOfBuild({
  onExplore
}: ProofOfBuildProps) {
  return <Reveal delay={0.06} data-id="element-815" data-mp="33omkykevayya">
      <div className="mt-14 border-t border-gray-200/70 pt-12 md:mt-16 md:pt-14" data-id="element-816" data-mp="2znubpr5zwu20">
        {/* Row 1 — copy */}
        <div className="max-w-2xl" data-id="element-817" data-mp="2uohjeqwcuus1">
          <Eyebrow data-id="element-818" data-mp="2ung244oqxc1v">Proof of build</Eyebrow>
          <h3 className="mt-3 font-serif text-2xl leading-[1.12] text-navy md:text-4xl" data-id="element-819" data-mp="2ppmztmqkd26v">
            From book idea to
            <br data-id="element-820" data-mp="1ja3wppdc8ldl" />
            <span className="italic text-seaglass" data-id="element-821" data-mp="1jam0r868s3w2">working reader path.</span>
          </h3>
          <p className="mt-4 text-base leading-relaxed text-text-muted md:text-lg" data-id="element-822" data-mp="1ea822gqj66ap">
            A physical book on one side. A working reader path on the other.
            Each surface turns anonymous interest into signal you can act on.
          </p>
        </div>

        {/* Row 2 — images */}
        <div className="mt-10 grid items-center gap-6 sm:mt-12 sm:grid-cols-[minmax(0,0.9fr)_auto_minmax(0,1.2fr)] sm:gap-8 md:gap-10" data-id="element-823" data-mp="2ae6v5wpzgpe">
          <button type="button" onClick={onExplore} className="group justify-self-center focus:outline-none focus-visible:ring-2 focus-visible:ring-seaglass focus-visible:ring-offset-2 focus-visible:ring-offset-paper-dark sm:justify-self-end" aria-label="Explore the working prototype: Find what applies" data-id="element-824" data-mp="76uu7xw3hr1f">
            <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/4wv71qfbbbwbngbvre9mbk/67ed1325-767e-4f35-bd1c-b49fa7a310ff/proof/simplify-to-amplify-book.webp" alt="Simplify to Amplify by Marni Hale" className="h-auto w-full max-w-[11rem] object-contain drop-shadow-[0_24px_40px_-20px_rgba(26,40,56,0.45)] transition-transform duration-300 group-hover:-translate-y-0.5 sm:max-w-[13rem]" loading="lazy" decoding="async" data-id="element-825" data-mp="3fqc2b6cb9euk" />
          </button>

          <div className="flex flex-col items-center gap-3 justify-self-center px-2" data-id="element-826" data-mp="2mtb0lfhjuswg">
            <span className="h-px w-10 bg-seaglass/35" aria-hidden="true" data-id="element-827" data-mp="2hu6q8liw2p4j" />
            <p className="max-w-[11rem] text-center font-serif text-base italic leading-snug text-seaglass md:text-lg" data-id="element-828" data-mp="2cw5bgcshxbyv">
              The same ideas, working for your business.
            </p>
            <span className="h-px w-10 bg-seaglass/35" aria-hidden="true" data-id="element-829" data-mp="35ku2tk3r22xf" />
          </div>

          <button type="button" onClick={onExplore} className="w-full max-w-md justify-self-center overflow-hidden rounded-2xl bg-white p-2.5 shadow-[0_40px_80px_-30px_rgba(26,40,56,0.55)] ring-1 ring-black/5 transition-[transform,box-shadow] duration-300 hover:-translate-y-0.5 hover:shadow-[0_28px_50px_-28px_rgba(26,40,56,0.45)] focus:outline-none focus-visible:ring-2 focus-visible:ring-seaglass focus-visible:ring-offset-2 focus-visible:ring-offset-paper-dark sm:justify-self-start sm:p-3" aria-label="Explore the working prototype: Find what applies" data-id="element-830" data-mp="30lhhj3sj13wy">
            <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/4wv71qfbbbwbngbvre9mbk/67ed1325-767e-4f35-bd1c-b49fa7a310ff/proof/book-to-laptop.webp" alt="A book transforming into a laptop — the path from manuscript to working reader experience" className="h-auto w-full rounded-lg object-contain" loading="lazy" decoding="async" data-id="element-831" data-mp="4otdmf7krejg" />
          </button>
        </div>

        {/* Composition footer — attribution closes the strip */}
        <div className="mt-8 flex items-baseline gap-3 border-t border-gray-200/70 pt-5 md:mt-10 md:pt-6" data-id="element-832" data-mp="sdcp13lx87fr">
          <span className="text-[0.65rem] font-semibold uppercase tracking-[0.2em] text-text-muted/70" data-id="element-833" data-mp="xd7fj61sav0a">
            Sample build
          </span>
          <span className="text-text-muted/35" aria-hidden="true" data-id="element-834" data-mp="2u7bxlh7nsaor">
            ·
          </span>
          <span className="text-[0.7rem] font-semibold uppercase tracking-[0.14em] text-navy/70" data-id="element-835" data-mp="2z6erc5i6uuhf">
            Simplify to Amplify by Marni Hale
          </span>
        </div>
      </div>
    </Reveal>;
}